module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_card_1_.cf591939.png";